import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import { Button, ModalInfo } from '@/components';

import exampleImage from '@/assets/images/compliance/transaction-alerts/table-example.webp';

import styles from './TransactionAlertsHowItWorksModal.module.sass';

interface TransactionAlertsHowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TransactionAlertsHowItWorksModal = ({
  isOpen,
  onClose,
}: TransactionAlertsHowItWorksModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalInfo
      isOpen={isOpen}
      title={t('translation.how_it_works')}
      actions={
        <Button
          size="s"
          type="primary"
          corner="rect"
          minWidth={120}
          onClick={onClose}
        >
          {t('translation.got_it')}
        </Button>
      }
      className={styles.modal}
      onClose={onClose}
    >
      <div className={styles.text}>
        {parse(t('translation.alerts_settings_how_it_works_modal.description'))}
      </div>

      <div className={styles.top}>
        <div className={styles.note}>
          {t('translation.alerts_settings_how_it_works_modal.example')}
        </div>

        <div className={cx(styles.message, styles.message0)}>
          {t('translation.alerts_settings_how_it_works_modal.badge1')}
        </div>
      </div>

      <img src={exampleImage} alt="" />

      <div className={styles.bottom}>
        <div className={cx(styles.message, styles.messageTop, styles.message1)}>
          {t('translation.alerts_settings_how_it_works_modal.badge2')}
        </div>

        <div className={cx(styles.message, styles.messageTop, styles.message2)}>
          {t('translation.alerts_settings_how_it_works_modal.badge3')}
        </div>
      </div>
    </ModalInfo>
  );
};

export default TransactionAlertsHowItWorksModal;
